var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_872_3014)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87505 0C6.04658 0 5.37527 0.656385 5.37527 1.46643C5.37527 1.87119 5.03935 2.19964 4.62538 2.19964H1.12484C0.503618 2.20015 0 2.69257 0 3.29997C0 3.90738 0.503618 4.39979 1.12484 4.39979H16.8752C17.4964 4.39979 18 3.90738 18 3.29997C18 2.69257 17.4964 2.20015 16.8752 2.20015H13.3741C12.9601 2.20015 12.6247 1.8717 12.6247 1.46694C12.6247 0.656901 11.9534 0.000515621 11.125 0.000515621H6.87505V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25022 6.59961C1.93539 6.59961 1.63533 6.72851 1.42228 6.95487C1.20923 7.18123 1.1027 7.48441 1.12907 7.79121L1.99603 17.9654C2.19063 20.246 4.14023 22.0002 6.48061 22.0002H11.52C13.8603 22.0002 15.8099 20.246 16.0045 17.9654L16.8715 7.79121C16.8979 7.48441 16.7913 7.18123 16.5783 6.95487C16.3652 6.72851 16.0652 6.59961 15.7503 6.59961H2.25022Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_872_3014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/Bin.a21ea0306752b0bd5bd44d258c78b564.svg";
export { ForwardRef as ReactComponent };